import CollectionCard from './CollectionCard';

export default CollectionCard;



// WEBPACK FOOTER //
// ./src/scenes/Store/components/CollectionCard/index.ts